import React from 'react';
import './DeveloperCredit.css';

const DeveloperCredit = ({ variant = 'default' }) => (
  <p className={`developer-credit developer-credit--${variant}`} aria-hidden="true">
    Developed by: Justine Jaimes Ornido
  </p>
);

export default DeveloperCredit;
